<template>
  <select
    class="LanguageSwitcher"
    name="language"
    @change="changeLanguage"
  >

    <option value="en">Show translation in</option>

    <option
      v-for="lang in languages"
      :key="lang.iso"
      :selected="isCurrentLanguage(lang.iso)"
      :class="{ 'is-selected': isCurrentLanguage(lang.iso) }"
      :value="lang.iso"
      v-if="prop_label==1"
      >
      {{ lang.label }}
    </option>


    <option
      v-for="lang in supportedLanguages"
      :key="lang"
      :selected="isCurrentLanguage(lang)"
      :class="{ 'is-selected': isCurrentLanguage(lang) }"
      :value="lang"
      v-if="prop_label!=1"
      >
      {{ lang }}
    </option>

  </select>
</template>
<script>
import { Trans } from '@/plugins/Translation'
import i18n from '../../i18n'
import Constant from '@/const.js'

export default {
  props: {
    'prop_label' : Number
  },
  data : function(){
    return {
      languages : []
    } 
  }, 
  computed: {
    supportedLanguages () {
      this.languages = Constant.languages.filter( l => l != 'en' ).map( lang => {
        return {
          iso : lang , 
          label : Constant.languages_labels.find( l => { return lang == l.iso }).label  , 
        }
      } )
      return Constant.languages ; // process.env.VUE_APP_I18N_SUPPORTED_LANGUAGES
    },
    currentLanguage () {
      return ( this.$route.params.lang != undefined) ? this.$route.params.lang : i18n.locale
    }
  },
  methods: {
    changeLanguage (e) {
      const lang = e.target.value
      const to = this.$router.resolve({ params: { lang } })
      
      this.$emit('emitChangeLanguage',lang)


      //return Trans.changeLanguage(lang).then(() => {
        
        // catch changing language from selector
        // this.$emit('emitChangeLanguage',lang)

        // this.$router.push(to.location)
      //})
    },
    isCurrentLanguage (lang) {
      return lang === this.currentLanguage
    }
  }
}
</script>

<style>
.LanguageSwitcher {
  margin-bottom: 1rem;
}
</style>
